var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{attrs:{"title":"当前网速较慢，页面加载失败，请刷新重试！","type":"error","closable":false,"center":""}})}
var staticRenderFns = []

export { render, staticRenderFns }